import { render, staticRenderFns } from "./ParcelExporterSection.vue?vue&type=template&id=48449079&scoped=true&"
import script from "./ParcelExporterSection.vue?vue&type=script&lang=js&"
export * from "./ParcelExporterSection.vue?vue&type=script&lang=js&"
import style0 from "./ParcelExporterSection.vue?vue&type=style&index=0&id=48449079&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48449079",
  null
  
)

export default component.exports